import React from 'react';
import { useCart } from '../../contexts/CartContext';

const CartIcon = () => {
  const { getCartTotals, toggleCart } = useCart();
  const { itemCount } = getCartTotals();

  if (itemCount === 0) {
    return null; // Hide cart icon when cart is empty
  }

  return (
    <button
      onClick={toggleCart}
      className="fixed top-4 right-4 z-50 bg-chess-green hover:bg-chess-green-dark text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg transition-all transform hover:scale-110 md:w-16 md:h-16"
      aria-label="Open shopping cart"
    >
      <div className="relative">
        <i className="fas fa-shopping-cart text-xl md:text-2xl"></i>
        {itemCount > 0 && (
          <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center md:w-6 md:h-6 md:text-sm">
            {itemCount > 9 ? '9+' : itemCount}
          </span>
        )}
      </div>
    </button>
  );
};

export default CartIcon;
